import { Modal } from 'antd';
import styles from './CheckpointModal.module.scss';

const CheckpointModal = ({
    isOpen,
    questionsAnswered,
    correctAnswers,
    timeSpent,
    onContinue,
    onEnd
}) => {
    return (
        <Modal
            open={isOpen}
            footer={null}
            closable={false}
            centered
            width={650}
            className={styles.checkpointModal}
            maskStyle={{ backgroundColor: 'rgba(12, 5, 109, 0.8)' }}
        >
            <div className={styles.checkpointContent}>
                <div className={styles.checkpointHeader}>
                    <div className={styles.checkIcon}>
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="28" cy="28" r="24" fill="#4caf50" opacity="0.15" />
                            <circle cx="28" cy="28" r="20" fill="#4caf50" opacity="0.2" />
                            <path d="M18 28L24 34L38 20" stroke="#4caf50" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h2 className={styles.title}>Checkpoint Reached!</h2>
                    <p className={styles.subtitle}>You've completed 25 questions. Here's your progress:</p>
                </div>

                <div className={styles.statsSection}>
                    <div className={styles.statsGrid}>
                        <div className={styles.statCard}>
                            <div className={styles.statIcon}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="4" y="4" width="24" height="24" rx="4" fill="#220ec9" opacity="0.1" />
                                    <path d="M10 16L14 20L22 12" stroke="#220ec9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.statValue}>{questionsAnswered}</div>
                            <div className={styles.statLabel}>Questions Answered</div>
                        </div>

                        <div className={styles.statCard}>
                            <div className={styles.statIcon}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="16" cy="16" r="12" fill="#4caf50" opacity="0.1" />
                                    <path d="M10 16L14 20L22 12" stroke="#4caf50" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.statValue}>{correctAnswers}</div>
                            <div className={styles.statLabel}>Correct Answers</div>
                        </div>

                        <div className={styles.statCard}>
                            <div className={styles.statIcon}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="16" cy="16" r="12" stroke="#FFD700" strokeWidth="2.5" fill="none" opacity="0.3" />
                                    <path d="M16 8V16L20 20" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.statValue}>{timeSpent}</div>
                            <div className={styles.statLabel}>Time Spent</div>
                        </div>
                    </div>
                </div>

                <div className={styles.buttonContainer}>
                    <button
                        className={styles.continueButton}
                        onClick={onContinue}
                    >
                        Continue Practice
                    </button>

                    <button
                        className={styles.endButton}
                        onClick={onEnd}
                    >
                        End Session
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CheckpointModal;
